import { useMemo } from 'react';
import { Variant } from '@loomstateorg/shared-frontend/types/product';

const useVariantWithDiscount = (variants: Partial<Variant>[]) => {
  const variant = useMemo(() => {
    return variants.reduce(
      (acc: Partial<Variant> | undefined, curr) =>
        curr.discountedPrice &&
        (!acc ||
          ((acc as Partial<Variant>)?.discountedPrice?.centAmount || 0) > (curr.discountedPrice?.centAmount || 0))
          ? curr
          : acc,
      undefined,
    );
  }, [variants]);

  return variant;
};

export default useVariantWithDiscount;
